export const TransferMAAI = {
    convert_tip: "โอนคะแนนไปยัง MAAI BY KTC",
    convert_success : "โอน Coin สำเร็จ",
    please_enter: "กรุณาใส่จำนวน Coin ที่จะทำการโอน",
    Continue: "ดำเนินการต่อ",
    Cancel: "ยกเลิก",
    your_tip_coin: "TIP Coin ของคุณ",
    back_home: "กลับหน้าหลัก",

    confirm_convert: "ยืนยัน",
    tip_coin: "TIP Coin",
    MAAI_point: "MAAI Point",
    conversion_undone: "เมื่อทำการโอนแล้ว ไม่สามารถยกเลิกได้",
    Member: "สมาชิก",

    convert_error: "โอนไม่สำเร็จ",
    please_contact_callcanter: "โปรดติดต่อ Call Center โทร",
    Close: "ปิด",

    something_wrong : "เกิดข้อผิดพลาดบางอย่าง",
    sorry: "ขออภัย เราไม่สามารถดำเนินการตามคำขอของคุณได้<br>กรุณาลองอีกครั้ง",
    tranfer_to_maai: "โอนคะแนนไป MAAI BY KTC",
    receive_from_maai: "ได้รับคะแนนจาก MAAI BY KTC",
    transfer_earn: "ได้รับคะแนนจาก ",
    transfer_coins: "โอนคะแนนไป ",
}

